import {Component, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router} from '@angular/router';
import {AcceptDeclineDialogComponent} from "./dialog/accept-decline-dialog/accept-decline-dialog.component";
// import {OAuthService} from "angular-oauth2-oidc";
import {MatDialog} from '@angular/material';
import {Xml} from "./model/Xml";
import {environment} from "../environments/environment";
import {AuthService} from './service/auth/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit  {

    router: Router;
    state: string;

    isLoggedIn = false;

    constructor(private _router: Router,
                private translate: TranslateService,
                public dialog: MatDialog,
                private authService: AuthService) {

        this.router = _router;
        translate.setDefaultLang('en');
        translate.use('en');
    }

    ngOnInit(): void {
      // this.isLoggedIn = this.authService.isLoggedIn();
      this.authService.getIsLoggedInSubject().subscribe((isLoggedIn: boolean) => {
        this.isLoggedIn = isLoggedIn;

        if (sessionStorage.getItem('calledNewPackage') === 'true') {
          this.isLoggedIn = true;
          sessionStorage.setItem('calledNewPackage', 'false');
        }
      });
    }

    getUsername() {
        return 'Bentley User';
    }

    // isLoggedIn() {
    //     return true;
    // }
    //
    // logout() {
    //   window.open(`${environment.basicAuthLogout}`,"_self");
    //   console.log('LOGOUT: ' + `${environment.basicAuthLogout}`);
    // }

  logout() {
    this.authService.logout();
    this.isLoggedIn = false;
    this.router.navigate(['/login']);
  }

    changeLang(lang: string) {
        this.translate.use(lang);
    }

    createNewPkgDialog() {

      const dialogRef = this.dialog.open(AcceptDeclineDialogComponent, {
        width: '250px',
        data: {
          title: this.translate.instant('DIALOG.ACCEPT_DECLINE_DIALOG.TITLE'),
          message: this.translate.instant('Do you want to create a new package? Unsaved data will be lost.'),
          icon: {
            add: false,
            name: ''
          }}
      });

      dialogRef.afterClosed().subscribe(result => {
        if(result == true) {
          sessionStorage.removeItem('currentPackageId');
          // this._router.navigate(['/upload/metadata?refresh=1']);
          window.location.reload();

          sessionStorage.setItem('calledNewPackage', 'true');

          console.log('Create new Pkg Dialog...');
        }
      });

    }
}
